module.exports = __webpack_public_path__ + "static/caleb-16eb76b72dbb66a656968bbd0762f4aa.png";